export const FOLD_TYPE = {
    ARROW: 'arrow',
    TEXT_ARROW: 'text arrow'
};

export const BTN_POSITION = {
    BOTTOM: 'bottom',
    RIGHT: 'right',
    RIGHT_BOTTOM: 'right-bottom'
};
